export const environment = {
  production: false,
  environmentName: 'DEVELOPMENT (Deployed)',
  apiUrl: 'https://devfunctiontmav1-eudcgtfff5fyfzhg.eastus2-01.azurewebsites.net/api',
  signalRUrl: 'https://devfunctiontmav1-eudcgtfff5fyfzhg.eastus2-01.azurewebsites.net/api',
  functionKey: 'd57vlbZKh8zApvU1LSSh8EzO-sg_oaTuy-Q21vP2AW5OAzFuvQc3Mw==',
  useMockService: false,
  logging: {
    level: 'info',
    enableSignalRLogging: false
  },
  msal: {
    clientId: '7f6451bd-d1b5-4cfa-a288-cff6fa6c1a95',
    authority: 'https://login.microsoftonline.com/common',
    apiScope: 'api://triadmedicalanalytics.com/access_as_user'
  }
};
